"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ERC20_json_1 = __importDefault(require("@renproject/sol/build/erc/ERC20.json"));
var BasicAdapter_json_1 = __importDefault(require("@renproject/sol/build/mainnet/BasicAdapter.json"));
var BCHGateway_json_1 = __importDefault(require("@renproject/sol/build/mainnet/BCHGateway.json"));
var BTCGateway_json_1 = __importDefault(require("@renproject/sol/build/mainnet/BTCGateway.json"));
var DarknodePayment_json_1 = __importDefault(require("@renproject/sol/build/mainnet/DarknodePayment.json"));
var DarknodePaymentStore_json_1 = __importDefault(require("@renproject/sol/build/mainnet/DarknodePaymentStore.json"));
var DarknodeRegistryLogicV1_json_1 = __importDefault(require("@renproject/sol/build/mainnet/DarknodeRegistryLogicV1.json"));
var DarknodeRegistryProxy_json_1 = __importDefault(require("@renproject/sol/build/mainnet/DarknodeRegistryProxy.json"));
var DarknodeRegistryStore_json_1 = __importDefault(require("@renproject/sol/build/mainnet/DarknodeRegistryStore.json"));
var DarknodeSlasher_json_1 = __importDefault(require("@renproject/sol/build/mainnet/DarknodeSlasher.json"));
var GatewayLogicV1_json_1 = __importDefault(require("@renproject/sol/build/mainnet/GatewayLogicV1.json"));
var GatewayRegistry_json_1 = __importDefault(require("@renproject/sol/build/mainnet/GatewayRegistry.json"));
var ProtocolLogicV1_json_1 = __importDefault(require("@renproject/sol/build/mainnet/ProtocolLogicV1.json"));
var ProtocolProxy_json_1 = __importDefault(require("@renproject/sol/build/mainnet/ProtocolProxy.json"));
var RenBCH_json_1 = __importDefault(require("@renproject/sol/build/mainnet/RenBCH.json"));
var RenBTC_json_1 = __importDefault(require("@renproject/sol/build/mainnet/RenBTC.json"));
var RenToken_json_1 = __importDefault(require("@renproject/sol/build/mainnet/RenToken.json"));
var RenZEC_json_1 = __importDefault(require("@renproject/sol/build/mainnet/RenZEC.json"));
var ZECGateway_json_1 = __importDefault(require("@renproject/sol/build/mainnet/ZECGateway.json"));
var network_1 = require("./network");
var networkID = 1;
// mintAuthority is generated by
// > utils.toChecksumAddress(utils.pubToAddress("... public key ...", true).toString("hex"))
exports["default"] = network_1.CastNetwork({
    version: "1.0.0",
    name: "mainnet",
    chain: "main",
    isTestnet: false,
    label: "Mainnet",
    chainLabel: "Mainnet",
    networkID: networkID,
    infura: "https://mainnet.infura.io",
    etherscan: "https://etherscan.io",
    lightnode: "https://lightnode-mainnet.herokuapp.com",
    addresses: {
        ren: {
            Protocol: {
                address: ProtocolProxy_json_1["default"].networks[networkID].address,
                abi: ProtocolLogicV1_json_1["default"].abi,
                artifact: ProtocolProxy_json_1["default"]
            },
            DarknodeSlasher: {
                address: DarknodeSlasher_json_1["default"].networks[networkID].address,
                abi: DarknodeSlasher_json_1["default"].abi,
                artifact: DarknodeSlasher_json_1["default"]
            },
            DarknodeRegistry: {
                address: DarknodeRegistryProxy_json_1["default"].networks[networkID].address,
                abi: DarknodeRegistryLogicV1_json_1["default"].abi,
                artifact: DarknodeRegistryLogicV1_json_1["default"],
                block: 9828748
            },
            DarknodeRegistryStore: {
                address: DarknodeRegistryStore_json_1["default"].networks[networkID].address,
                abi: DarknodeRegistryStore_json_1["default"].abi,
                artifact: DarknodeRegistryStore_json_1["default"]
            },
            DarknodePayment: {
                address: DarknodePayment_json_1["default"].networks[networkID].address,
                abi: DarknodePayment_json_1["default"].abi,
                artifact: DarknodePayment_json_1["default"]
            },
            DarknodePaymentStore: {
                address: DarknodePaymentStore_json_1["default"].networks[networkID].address,
                abi: DarknodePaymentStore_json_1["default"].abi,
                artifact: DarknodePaymentStore_json_1["default"]
            }
        },
        gateways: {
            GatewayRegistry: {
                address: GatewayRegistry_json_1["default"].networks[networkID].address,
                abi: GatewayRegistry_json_1["default"].abi,
                artifact: GatewayRegistry_json_1["default"]
            },
            RenBTC: {
                _address: RenBTC_json_1["default"].networks[networkID].address,
                abi: RenBTC_json_1["default"].abi,
                artifact: RenBTC_json_1["default"],
                description: "gatewayRegistry.getTokenBySymbol(\"BTC\")"
            },
            BTCGateway: {
                _address: BTCGateway_json_1["default"].networks[networkID].address,
                abi: GatewayLogicV1_json_1["default"].abi,
                artifact: GatewayLogicV1_json_1["default"],
                description: "gatewayRegistry.getGatewayBySymbol(\"BTC\")"
            },
            RenZEC: {
                _address: RenZEC_json_1["default"].networks[networkID].address,
                abi: RenZEC_json_1["default"].abi,
                artifact: RenZEC_json_1["default"],
                description: "gatewayRegistry.getTokenBySymbol(\"ZEC\")"
            },
            ZECGateway: {
                _address: ZECGateway_json_1["default"].networks[networkID].address,
                abi: GatewayLogicV1_json_1["default"].abi,
                artifact: GatewayLogicV1_json_1["default"],
                description: "gatewayRegistry.getGatewayBySymbol(\"ZEC\")"
            },
            RenBCH: {
                _address: RenBCH_json_1["default"].networks[networkID].address,
                abi: RenBCH_json_1["default"].abi,
                artifact: RenBCH_json_1["default"],
                description: "gatewayRegistry.getTokenBySymbol(\"BCH\")"
            },
            BCHGateway: {
                _address: BCHGateway_json_1["default"].networks[networkID].address,
                abi: GatewayLogicV1_json_1["default"].abi,
                artifact: GatewayLogicV1_json_1["default"],
                description: "gatewayRegistry.getGatewayBySymbol(\"BCH\")"
            },
            BasicAdapter: {
                address: BasicAdapter_json_1["default"].networks[networkID].address,
                abi: BasicAdapter_json_1["default"].abi,
                artifact: BasicAdapter_json_1["default"]
            }
        },
        tokens: {
            DAI: {
                address: "0x6b175474e89094c44da98b954eedeac495271d0f",
                decimals: 18
            },
            BTC: {
                address: RenBTC_json_1["default"].networks[networkID].address,
                abi: RenBTC_json_1["default"].abi,
                artifact: RenBTC_json_1["default"],
                decimals: 8
            },
            ZEC: {
                address: RenZEC_json_1["default"].networks[networkID].address,
                abi: RenZEC_json_1["default"].abi,
                artifact: RenZEC_json_1["default"],
                decimals: 8
            },
            BCH: {
                address: RenBCH_json_1["default"].networks[networkID].address,
                abi: RenBCH_json_1["default"].abi,
                artifact: RenBCH_json_1["default"],
                decimals: 8
            },
            REN: {
                address: RenToken_json_1["default"].networks[networkID].address,
                abi: RenToken_json_1["default"].abi,
                artifact: RenToken_json_1["default"],
                decimals: 18
            },
            ETH: {
                address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                decimals: 18
            }
        },
        erc: {
            ERC20: {
                abi: ERC20_json_1["default"].abi,
                artifact: ERC20_json_1["default"]
            }
        }
    }
});
